export const SubscriptionStatusEnum = {
  INCOMPLETE: "INCOMPLETE",
  ACTIVE: "ACTIVE",
  CANCELLING: "CANCELLING",
  CANCELED: "CANCELED",
  INCOMPLETE_EXPIRED: "INCOMPLETE_EXPIRED",
  PAST_DUE: "PAST_DUE",
  PAUSED: "PAUSED",
  TRIALING: "TRIALING",
  UNPAID: "UNPAID",
} as const;
export type SubscriptionStatusEnum =
  (typeof SubscriptionStatusEnum)[keyof typeof SubscriptionStatusEnum];

export const PlanIntervalEnum = {
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  YEAR: "YEAR",
} as const;

export type PlanIntervalEnum =
  (typeof PlanIntervalEnum)[keyof typeof PlanIntervalEnum];

export type Subscription = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  stripeSubscriptionId: string | null;
  stripePriceId: string | null;
  stripeCurrentPeriodEnd: Date | null;
  status: SubscriptionStatusEnum;
  userId: number;
};

export type SubscriptionPlan = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  stripeProductId: string;
  stripePriceId: string;
  name: string;
  description: string | null;
  unitAmount: number;
  currency: string;
  interval: PlanIntervalEnum;
  intervalCount: number;
  active: boolean;
  metadata: Record<string, unknown> | null;
};

export type SubscriptionStatusResponse = {
  isActive: boolean;
  status: SubscriptionStatusEnum | null;
  currentPeriodEnd: Date | null;
  priceId: string | null;
};

export type CheckoutSessionPayload = {
  priceId: string;
  successUrl: string;
  cancelUrl: string;
};

export type CheckoutSessionResponse = {
  sessionId: string;
  url: string;
};

export type BillingPortalPayload = {
  returnUrl: string;
  purpose?: "subscription_management" | "payment_method_management";
};

export type BillingPortalResponse = {
  url: string;
};

export type SyncResult = {
  synced: number;
};

export type SuccessResponse = {
  success: boolean;
};
